import { CheckOutlined, MinusOutlined } from '@teko/ds-icon';
import React__default from 'react';
import { CommonStyles } from '../BaseProps/index.es.js';
import { Body } from '../Typography/index.es.js';
import styled from '@emotion/styled';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getColor = (props, type) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const displayColor = props.checked || props.partSelected;
  switch (type) {
    case "border": {
      if (props.disabled) {
        if (displayColor)
          return (_a = props.theme) == null ? void 0 : _a.colors.primary100;
        return (_b = props.theme) == null ? void 0 : _b.colors.divider;
      } else {
        if (displayColor)
          return (_c = props.theme) == null ? void 0 : _c.colors.primary500;
        return (_d = props.theme) == null ? void 0 : _d.colors.border;
      }
    }
    case "inner":
    default: {
      if (props.disabled) {
        if (displayColor)
          return (_e = props.theme) == null ? void 0 : _e.colors.primary100;
        return (_f = props.theme) == null ? void 0 : _f.colors.background;
      } else {
        if (displayColor)
          return (_g = props.theme) == null ? void 0 : _g.colors.primary500;
        return (_h = props.theme) == null ? void 0 : _h.colors.white;
      }
    }
  }
};
const Checkbox = (_a) => {
  var _b = _a, {
    checked = false,
    partSelected,
    disabled,
    onChange,
    children,
    className,
    borderRadius
  } = _b, rest = __objRest(_b, [
    "checked",
    "partSelected",
    "disabled",
    "onChange",
    "children",
    "className",
    "borderRadius"
  ]);
  return /* @__PURE__ */ React__default.createElement(CheckboxWrapper, __spreadProps(__spreadValues({}, rest), {
    className: "check-box"
  }), /* @__PURE__ */ React__default.createElement(StyledCheckbox, null, /* @__PURE__ */ React__default.createElement(StyledInput, {
    type: "checkbox",
    checked,
    disabled,
    partSelected,
    onChange: () => !disabled && onChange && onChange(!checked),
    className
  }), /* @__PURE__ */ React__default.createElement(CheckboxInner, {
    checked,
    partSelected,
    disabled,
    borderRadius,
    className: "checkbox-inner"
  }, partSelected ? /* @__PURE__ */ React__default.createElement(StyledMinusIcon, {
    size: 12,
    color: disabled ? "primary50" : "white"
  }) : /* @__PURE__ */ React__default.createElement(StyledCheckIcon, {
    size: 12,
    color: checked ? disabled ? "primary50" : "white" : "transparent"
  }))), children && /* @__PURE__ */ React__default.createElement(Body, {
    line: 1,
    marginLeft: "s4",
    level: 1,
    weight: "regular",
    style: { flex: 1 },
    className: "checkbox-label"
  }, children));
};
const CheckboxWrapper = styled.label`
  display: inline-flex;
  align-items: center;
  line-height: unset;
  cursor: pointer;
  list-style: none;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  ${CommonStyles}
`;
const StyledCheckIcon = styled(CheckOutlined)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  path {
    stroke-width: 5;
  }
`;
const StyledMinusIcon = styled(MinusOutlined)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  path {
    stroke-width: 4;
    stroke: ${({ theme }) => theme == null ? void 0 : theme.colors.white};
  }
`;
const StyledCheckbox = styled.div`
  display: inline-block;
  position: relative;
  width: 16px;
  height: 16px;
`;
const CheckboxInner = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 16px;
  height: 16px;
  margin: auto;
  border: 1px solid ${(p) => getColor(p, "border")};
  border-radius: ${(p) => {
  var _a;
  return p.borderRadius ? (_a = p.theme) == null ? void 0 : _a.borderRadius[p.borderRadius] : "2px";
}};
  background-color: ${(p) => getColor(p, "inner")};
`;
const StyledInput = styled.input`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  width: 16px;
  height: 16px;
  margin: auto;
  cursor: ${(p) => p.disabled ? "not-allowed" : "pointer"};
  opacity: 0;
  ${(p) => !p.disabled && !p.checked && !p.partSelected ? `
      &:hover + .checkbox-inner {
        border-color: ${p.theme.colors.placeholder};
      }
    ` : ""}
`;

export { Checkbox };
